<template>
  <transition name="fade">
      <div class="level-popup-wrapper" v-show="levelChangeData.show">
        <div class="level-popup">
          <div class="level-img">
            <img :src="levelChangeData.icon">
          </div>
          <div class="level-text">恭喜升为 {{levelChangeData.levelName}}{{levelChangeData.starLevel | formatStarLevel}}星</div>
        </div>
        <canvas id="canvas" width="340" height="200"></canvas>
      </div>
  </transition>
</template>
<script>
import paperFlow from './paperFlow.js'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('course', ['levelChangeData']),
  },
  filters: {
    formatStarLevel (value) {
      const level = ['Ⅰ', 'Ⅱ', 'Ⅲ']
      return level[value - 1]
    },
  },
  watch: {
    '$store.state.course.levelChangeData': {
      handler (newVal) {
        if (newVal.show) {
          paperFlow()
          setTimeout(() => {
            newVal.show = false
          }, 4000)
        }
      },
    },
  },
  methods: {
    testFunc () {
      this.test = true
    },
  },
}
</script>
<style lang="scss" scoped>
button{
  position:fixed;
  left:20px;
  top:20px;
  z-index:10;
}
.level-popup-wrapper{
  position:fixed;
  width:100%;
  left:0;
  top:0;
  z-index: 10000;
  canvas{
    position:absolute;
    left: 50%;
    transform: translateX(-50%);
    top:20px;
  }
  .level-popup {
    position: absolute;
    left: 50%;
    top: 80px;
    transform: translateX(-50%);
    border-radius: 22px;
    width: 220px;
    padding: 11px;
    line-height: 1.5;
    text-align: center;
    color: $color-white;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.5);
    background-image: linear-gradient(101deg, #d2a970, #ae8448);
    .level-img {
      position: absolute;
      left: -20px;
      top: -20px;
      img {
        height: 80px;
        width: 80px;
      }
    }
    .level-text {
      margin-left: 20px;
    }
  }
}
</style>
